import BaseTitle from "./BaseTitle.vue";
import BaseModule from "./BaseModule.vue";

const array = [
    BaseTitle,
    BaseModule
];

const baseComponents = {
    install(vue) {
        for (let i = 0; i < array.length; i++) {
            vue.component(array[i].name, array[i]);
        }
    },
};

export default baseComponents;



// WEBPACK FOOTER //
// ./src/components/index.js